import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import logoSendPostOffice from "../../../../assets/images/logoSendPostOffice.png";
import summaryPostOffice from "../../../../assets/images/summaryPostOffice.png";
import dayjs from "dayjs";

export async function excelForPostOfficeCC(rawData = [], typeExport, typeContract) {
  const exportMode = Number(typeExport) === 2 ? 2 : 1;
  const workbook = new ExcelJS.Workbook();
  // console.log("rawData", rawData);

  // โหลดรูปครั้งเดียว
  const [logoBuf, sumBuf] = await Promise.all([
    fetch(logoSendPostOffice).then((r) => r.arrayBuffer()),
    fetch(summaryPostOffice).then((r) => r.arrayBuffer()),
  ]);
  const logoId = workbook.addImage({ buffer: logoBuf, extension: "png" });
  const summaryId = workbook.addImage({ buffer: sumBuf, extension: "png" });

  // helper
  const setThinBorder = (cell) => {
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  };

  const createNewSheet = (idx) => {
    const ws = workbook.addWorksheet(String(idx));

    // --- ตั้งค่าหน้ากระดาษตามรูปภาพอ้างอิงล่าสุด ---
    ws.pageSetup = {
      paperSize: 9,          // A4
      orientation: 'portrait', // แนวตั้ง
      scale: 100,            // ไม่ปรับมาตราส่วน (ขนาดจริง 100%)
      margins: {
        top: 0.197,          // 0.5 ซม. (ปรับใหม่)
        bottom: 0.197,       // 0.5 ซม. (ปรับใหม่)
        left: 0.984,         // 2.5 ซม.
        right: 0.016,        // 0.04 ซม.
        header: 0.512,       // 1.3 ซม.
        footer: 0.512        // 1.3 ซม.
      }
    };

    // โลโก้
    ws.addImage(logoId, {
      tl: { col: 0, row: 2 },
      ext: { width: 180, height: 105 },
    });

    ws.mergeCells("A1:H1");
    ws.getCell("A1").value =
      "ใบนำส่งสิ่งของทางไปรษณีย์โดยชำระค่าบริการเป็นเงินเชื่อ";
    ws.getCell("A1").font = { bold: true, size: 16, name: "Angsana New" };
    ws.getCell("A1").alignment = { horizontal: "center" };

    ws.mergeCells("F5:G5");
    ws.getCell("F5").value = "วันที่/เดือน/ปี.....................";
    ws.getCell("F5").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("F5").alignment = { horizontal: "center" };

    ws.mergeCells("F6:G6");
    ws.getCell("G6").value = "บริษัท วัน มันนี่ จำกัด";
    ws.getCell("G6").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("F6").alignment = { horizontal: "center" };

    ws.mergeCells("F7:G7");
    ws.getCell("G7").value = "ใบอนุญาตเลขที่ 215/2560";
    ws.getCell("G7").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("F7").alignment = { horizontal: "center" };

    ws.mergeCells("A8:E8");
    ws.getCell("A8").value =
      "ได้ฝากส่งสิ่งของส่งทางไปรษณีย์โดยชำระค่าบริการเป็นเงินเชื่อดังรายการต่อไปนี้";
    ws.getCell("A8").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("A8").alignment = { horizontal: "left" }; // แก้จาก lift -> left

    ws.mergeCells("F8:G8");
    ws.getCell("F8").value = "ศฝ/ปณ.เทพารักษ์  40001";
    ws.getCell("F8").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("F8").alignment = { horizontal: "center" };

    ws.mergeCells("F9:G9");
    ws.getCell("F9").value = "ฝากส่งครั้งที่..............ของเดือนนี้";
    ws.getCell("F9").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("F9").alignment = { horizontal: "center" };

    ws.getColumn(1).width = 5;
    ws.mergeCells("A10:A11");
    ws.getCell("A10").value = "ลำดับ";
    ws.getCell("A10").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("A10").alignment = { horizontal: "center", vertical: "middle" };
    setThinBorder(ws.getCell("A10"));

    ws.getColumn(2).width = 23;
    ws.mergeCells("B10:B11");
    ws.getCell("B10").value = "ผู้รับ";
    ws.getCell("B10").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("B10").alignment = { horizontal: "center", vertical: "middle" };
    setThinBorder(ws.getCell("B10"));

    ws.getColumn(3).width = 8;
    ws.mergeCells("C10:C11");
    ws.getCell("C10").value = "ปลายทาง";
    ws.getCell("C10").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("C10").alignment = { horizontal: "center", vertical: "middle" };
    setThinBorder(ws.getCell("C10"));

    ws.getColumn(4).width = 6;
    ws.getCell("D11").value = "ธรรมดา";
    ws.getCell("D11").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("D11").alignment = { horizontal: "center" };
    setThinBorder(ws.getCell("D10")); // header แถวบน
    setThinBorder(ws.getCell("D11"));

    // ตำแหน่งหัวคอลัมน์เลขบริการ
    const pos = exportMode === 1 ? "E10" : "F10";
    ws.getCell(pos).value = "เลขที่บริการ (13 หลัก)";
    ws.getCell(pos).font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell(pos).alignment = { horizontal: "center" };
    setThinBorder(ws.getCell("E10"));
    setThinBorder(ws.getCell("F10"));

    const sizes = exportMode === 1 ? [15, 10] : [10, 15];
    ws.getColumn(5).width = sizes[0];
    ws.getCell("E11").value = "ลงทะเบียน";
    ws.getCell("E11").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("E11").alignment = { horizontal: "center" };
    setThinBorder(ws.getCell("E11"));

    ws.getColumn(6).width = sizes[1];
    ws.getCell("F11").value = "EMS";
    ws.getCell("F11").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("F11").alignment = { horizontal: "center" };
    setThinBorder(ws.getCell("F11"));

    ws.getColumn(7).width = 7;
    ws.mergeCells("G10:G11");
    ws.getCell("G10").value = "ค่าบริการ";
    ws.getCell("G10").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("G10").alignment = { horizontal: "center", vertical: "middle" };
    setThinBorder(ws.getCell("G10"));

    ws.getColumn(8).width = 7;
    ws.mergeCells("H10:H11");
    ws.getCell("H10").value = "หมายเหตุ";
    ws.getCell("H10").font = { bold: true, size: 14, name: "Angsana New" };
    ws.getCell("H10").alignment = { horizontal: "center", vertical: "middle" };
    setThinBorder(ws.getCell("H10"));

    return ws;
  };

  // sort & ทำสำเนาเพื่อไม่แก้ของเดิม
  const data = (Array.isArray(rawData) ? rawData : [])
    .slice()
    .sort((a, b) =>
      String(a.parcelNo || "").localeCompare(
        String(b.parcelNo || ""),
        undefined,
        { numeric: true }
      )
    );

  let sheetIndex = 1;
  let ws = createNewSheet(sheetIndex);
  let rowIndex = 12;
  let recNo = 1;

  data.forEach((row, i) => {
    // 15 แถวต่อชีต
    if (i > 0 && i % 15 === 0) {
      sheetIndex += 1;
      ws = createNewSheet(sheetIndex);
      rowIndex = 12;
      recNo = 1;
    }

    const onlyDigits = String(row.customerTypeId ?? "").replace(/\D/g, "");
    const garNum = onlyDigits ? Number(onlyDigits) : "";
    var guaType = `คค ${garNum}.`
    if (garNum === 0) {
      guaType = `ผชซ.`
    }

    ws.addRow([
      recNo,
      // row.key,
      row.customerFullname ?? "",
      row.zipcode ?
        row.zipcode : row.ZIP ? row.ZIP : "",
      guaType,
      exportMode === 1 ? row.parcelNo ?? "" : row.contractNo ?? "",
      exportMode === 2 ? row.parcelNo ?? "" : row.contractNo ?? "",
      "",
      "",
    ]);

    const r = ws.getRow(rowIndex);
    r.alignment = { vertical: "middle", horizontal: "center" };
    r.font = { name: "Angsana New", size: 14 };
    r.eachCell((cell) => setThinBorder(cell));

    // ให้คอลัมน์ชื่อผู้รับชิดซ้าย
    ws.getCell(`B${rowIndex}`).alignment = {
      vertical: "middle",
      horizontal: "left",
    };

    rowIndex += 1;
    recNo += 1;
  });

  // ใส่สรุป/ภาพท้ายแต่ละชีต
  workbook.eachSheet((ws) => {
    const last = ws.lastRow?.number ?? 11;
    const base = last + 2;

    ws.mergeCells(`D${base + 1}:G${base + 1}`);
    ws.getCell(`D${base + 1}`).value =
      "ไปรษณียภัณฑ์ธรรมดา         รวม  Express  จำนวน..........................ชิ้น";
    ws.getCell(`D${base + 1}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };
    ws.getCell(`D${base + 2}`).value = "รวมทั้งสิ้น";
    ws.getCell(`D${base + 2}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    ws.getCell(`D${base + 3}`).value =
      "(ตัวอักษร).................................................................................";
    ws.getCell(`D${base + 3}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    ws.getCell(`D${base + 4}`).value = "ได้ตรวจสอบความถูกต้องแล้ว";
    ws.getCell(`D${base + 4}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    ws.getCell(`F${base + 5}`).value = "ตราประจำวัน";
    ws.getCell(`F${base + 5}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    ws.getCell(`D${base + 6}`).value =
      "ลงชื่อ..............................................";
    ws.getCell(`D${base + 6}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    ws.getCell(`D${base + 7}`).value = "เจ้าหน้าที่ผู้รับผิดชอบในการฝากส่ง";
    ws.getCell(`D${base + 7}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    ws.getCell(`F${base + 7}`).value = "ได้ตรวจสอบและรับฝากไว้ถูกต้องแล้ว";
    ws.getCell(`F${base + 7}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    ws.getCell(`D${base + 9}`).value =
      "ลงชื่อ..............................................";
    ws.getCell(`D${base + 9}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    ws.getCell(`F${base + 9}`).value =
      "ลงชื่อ.............................................";
    ws.getCell(`F${base + 9}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    ws.getCell(`D${base + 10}`).value = "        เจ้าหน้าที่ผู้ฝากส่ง";
    ws.getCell(`D${base + 10}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    ws.getCell(`F${base + 10}`).value = "  เจ้าหน้าที่ผู้รับฝาก";
    ws.getCell(`F${base + 10}`).font = {
      bold: true,
      size: 14,
      name: "Angsana New",
    };

    // ใส่รูปสรุป
    ws.addImage(summaryId, {
      tl: { col: 0, row: base },
      ext: { width: 240, height: 170 },
    });
  });

  // สร้างไฟล์
  const buf = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(
    blob,
    `นำส่งไปรษณีย์${typeContract ? typeContract.label : ""} ${dayjs().format("DD-MM-YYYY")}.xlsx`
  );
}
